import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Divider,
  Avatar,
  MenuItem,
  ListItemIcon,
  Menu,
} from "@mui/material";
import { IoIosArrowForward } from "react-icons/io";
import { RiMailDownloadFill } from "react-icons/ri";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { RiCloseCircleFill } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import { RiMailCloseFill } from "react-icons/ri";
import { MdOutlineWarning } from "react-icons/md";
import moment from "moment";
import {
  DotsThreeOutlineVertical,
} from "@phosphor-icons/react";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import {
  setExternalChatData,
  setUserlistShow,
  GetAllUsers,
  UpdateExternalContactList,
} from "../../../../../Redux/Actions/actions";
import EndChatModel from "../../chat-component-model/End-chat-model";
import TransferSkillset from "../../chat-component-model/TransferSkillset";
import Escalationmodel from "../../chat-component-model/Escalation-modal";
import EmailReschedul from "../../chat-component-model/Email-Reschedul";
import { toast } from "react-toastify";
import axios from "axios";
import {
  BaseUrl,
  emailservice,
} from "../../../../../Container/BaseUrl/BaseUrl";
import { toaststyle } from "../../../../../Utils/toaststyle";
import FileSaver from "file-saver";



const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    userlistshow: data.userlistshow,
    externalChatData: contactListData.externalChatData,
  };
};

const EmailConversationHeader = (props) => {
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [escalationmodal, setescalationmodal] = useState(false);
  const [transferskillsetmodal, setTransferskillsetmodal] = useState(false);
  const [endchatModalDialog, setendchatModalDialog] = useState(false);
  const [emailReschedualModalDialog, setemailReschedualModalDialog] =
    useState(false);
  const [selecteddate, setSelecteddate] = useState("");
  const [timeerror, setTimeerror] = useState(false);
  const [selectedtime, setSelectedtime] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleReschedule = () => {
    if (isDisabled()) {
      setTimeerror(true);
    } else {
      setTimeerror(false);
      rescheduleMailApi();
    }
  };
  const rescheduleMailApi = () => {
    const agent_Id = JSON.parse(localStorage.getItem("tokenAgent"));
    const session_id = JSON.parse(localStorage.getItem("client"));
    axios
      .post(
        BaseUrl + "/email/Reschduleemail",
        {
          session_id: session_id.chat_session_id,
          redate: selecteddate,
          time: selectedtime,
          agent_id: agent_Id.agent_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            Tenantid: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setSelecteddate("");
          props.setExternalChatData("");
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id
          );
          setSelectedtime(null);
          setemailReschedualModalDialog(false);
          toast.success(response.data.message, toaststyle);
        } else {
          props.setExternalChatData("");
          setemailReschedualModalDialog(false);
          toast.error(response.data.message, toaststyle);
          setSelecteddate("");
          setSelectedtime("");
        }
      })
      .catch((error) => {
        console.error(error);
        setemailReschedualModalDialog(false);
      });
  };
  const completedEmail = () => {
    let userId = JSON.parse(localStorage.getItem("tokenAgent"));
    let sessionId = JSON.parse(localStorage.getItem("client"));
    let agentId = userId.id;
    let datas = {
      chat_session_id: sessionId.chat_session_id,
      chatendby: "Agent",
      reason: "NetworkIssue",
      comment: "Completed",
      agent_id: agentId,
      ticket: true,
    };
    axios
      .post(BaseUrl + "/message/endchat", datas, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success) {
          props.setExternalChatData("");
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id
          );
          toast.success("Interaction Ended Successfully", toaststyle);
        } else {
          props.setExternalChatData("");
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.log("complete_email", error);
      });
  };
  const handleTimeChange = (e) => {
    const rawTime = e.target.value;
    const formattedTime = moment(rawTime, "HH:mm").format("LT");
    setSelectedtime(formattedTime);
  };
  const isDisabled = () => {
    if (!selectedtime || !selecteddate) return true;

    const currentDate = new Date(selecteddate);
    const currentTime = new Date();
    const selectedDateTime = new Date(currentDate);

    const [hours, minutes] = selectedtime.split(":");
    const selectedHours = parseInt(hours, 10);
    const selectedMinutes = parseInt(minutes, 10);

    if (selectedtime.includes("PM")) {
      selectedDateTime.setHours(selectedHours + 12);
    } else if (selectedtime.includes("AM")) {
      selectedDateTime.setHours(selectedHours);
    }

    selectedDateTime.setMinutes(selectedMinutes);
    return selectedDateTime < currentTime;
  };
  const emailDownloadAsPdf = () => {
    const selectedChat = JSON.parse(localStorage.getItem("client"));
    if (!selectedChat) return;
    axios
      .post(
        emailservice + "/emailDownloadAsPdf",
        {
          id: selectedChat.emailId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            Tenantid: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          let downloadEmailasPdf = `https://utils.ntt.inaipi.ae/email//files${res.data.data}`;
          FileSaver.saveAs(downloadEmailasPdf);
          toast.success(res.data.message, toaststyle);
        } else {
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.error("emailDownloadAsPdf", error);
      });
  };

  return (
    <>
      <Box
        sx={{
          height: "55px",
          width: "100%",
          backgroundColor: "white",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
        p={1}
      >
        <Stack
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <Stack direction={"row"} sx={{ width: "100%" }}>
            <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
              <Avatar
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  background: "#0B3363",
                }}
                className="box-inset2"
              >
                {props.externalChatData
                  ? props.externalChatData.unique_id
                    ? props.externalChatData.unique_id.email
                        .slice(0, 2)
                        .toUpperCase()
                    : ""
                  : ""}
              </Avatar>
              <Stack
                spacing={0.1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, fontSize: "13px" }}
                >
                  {props.externalChatData
                    ? props.externalChatData.unique_id
                      ? props.externalChatData.unique_id.email
                      : ""
                    : ""}
                </Typography>
              </Stack>
            </Stack>

            {props.noHeaderAction && (
              <Stack direction={"row"} alignItems={"center"}>
                <Tooltip title="Download Email" arrow placement="top">
                  <IconButton onClick={emailDownloadAsPdf}>
                    <RiMailDownloadFill size={17} />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Reschedule" arrow placement="top">
                  <IconButton
                    onClick={() => {
                      setemailReschedualModalDialog(true);
                    }}
                  >
                    <RiCalendarScheduleFill size={17} />
                  </IconButton>
                </Tooltip>

                <IconButton
                  aria-describedby={id}
                  onClick={(e) => {
                    handleClick(e);
                  }}
                >
                  <DotsThreeOutlineVertical size={17} weight="fill" />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  {permission.map((module) => {
                    if (module.moduleName === "EMAIL_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "ESCALATION_SUPERVISOR" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <MenuItem
                            onClick={() => {
                              setescalationmodal(true);
                              handleClose();
                            }}
                            sx={{ fontSize: "13px" }}
                          >
                            <ListItemIcon>
                              <MdOutlineWarning size={16} />
                            </ListItemIcon>
                            Escalation
                          </MenuItem>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <MenuItem sx={{ fontSize: "13px" }}>
                              <ListItemIcon>
                                <MdOutlineWarning size={16} />
                              </ListItemIcon>
                              Escalation
                            </MenuItem>
                          </Tooltip>
                        );
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "EMAIL_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "NOACTION_EMAIL" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <MenuItem
                            sx={{ fontSize: "13px" }}
                            onClick={() => {
                              completedEmail();
                            }}
                          >
                            <ListItemIcon>
                              <RiMailCloseFill size={16} />
                            </ListItemIcon>
                            No action email
                          </MenuItem>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <MenuItem sx={{ fontSize: "13px" }}>
                              <ListItemIcon>
                                <RiMailCloseFill size={16} />
                              </ListItemIcon>
                              No action email
                            </MenuItem>
                          </Tooltip>
                        );
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "EMAIL_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "TRANSFER_SKILLSET" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <MenuItem
                            sx={{ fontSize: "13px" }}
                            onClick={() => {
                              setTransferskillsetmodal(true);
                              handleClose();
                            }}
                          >
                            <ListItemIcon>
                              <BiTransferAlt size={16} />
                            </ListItemIcon>
                            Transfer to skillset
                          </MenuItem>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <MenuItem sx={{ fontSize: "13px" }}>
                              <ListItemIcon>
                                <BiTransferAlt size={16} />
                              </ListItemIcon>
                              Transfer to skillset
                            </MenuItem>
                          </Tooltip>
                        );
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "EMAIL_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "END_INTERACTION" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <MenuItem
                            sx={{ fontSize: "13px" }}
                            onClick={() => {
                              setendchatModalDialog(true);
                              handleClose();
                            }}
                          >
                            <ListItemIcon>
                              <RiCloseCircleFill size={16} />
                            </ListItemIcon>
                            End interaction
                          </MenuItem>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <MenuItem sx={{ fontSize: "13px" }}>
                              <ListItemIcon>
                                <RiCloseCircleFill size={16} />
                              </ListItemIcon>
                              End interaction
                            </MenuItem>
                          </Tooltip>
                        );
                      }
                    }
                  })}
                </Menu>
              </Stack>
            )}
          </Stack>

          <Stack direction={"row"}>
            <IconButton
              onClick={() => {
                props.setUserlistShow(!props.userlistshow);
              }}
            >
              <IoIosArrowForward
                size={16}
                className={
                  props.userlistshow
                    ? "userInfo-rotate-90"
                    : "userInfo-rotate-0"
                }
              />
            </IconButton>
          </Stack>
        </Stack>
      </Box>

      {escalationmodal && (
        <Escalationmodel
          show={escalationmodal}
          close={() => setescalationmodal(false)}
        />
      )}
      {transferskillsetmodal && (
        <TransferSkillset
          OpenDialog={transferskillsetmodal}
          handleClose={() => setTransferskillsetmodal(false)}
        />
      )}
      {endchatModalDialog && (
        <EndChatModel
          OpenDialog={endchatModalDialog}
          handleClose={() => setendchatModalDialog(false)}
        />
      )}
      {emailReschedualModalDialog && (
        <EmailReschedul
          OpenDialog={emailReschedualModalDialog}
          handleClose={() => setemailReschedualModalDialog(false)}
          setSelecteddate={setSelecteddate}
          selecteddate={selecteddate}
          timeerror={timeerror}
          selectedtime={selectedtime}
          handleTimeChange={handleTimeChange}
          handleReschedule={handleReschedule}
          isDisabled={isDisabled}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  setUserlistShow,
  GetAllUsers,
  UpdateExternalContactList,
})(EmailConversationHeader);
